<template>
  <div>可视化大屏管理</div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang='less' scoped>
</style>